import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import CustomTextInput from "../../components/ui/CustomTextInput/CustomTextInput";
import CustomButton from "../../components/ui/CustomButton/CustomButton";
import { requestPasswordResetValidators } from "../../lib/validations/authValidations";
import { toastService } from "../../providers";
import { useRequestPasswordReset } from "../../hooks/queries/useAuthQueries";
import AuthLayout from "../../components/auth/authLayout/AuthLayout";
import AuthCard from "../../components/auth/authCard/AuthCard";

function RequestPasswordReset() {
  const navigate = useNavigate();
  const { mutate: requestPasswordResetMutation, isPending } =
    useRequestPasswordReset();

  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: "",
    },
    mode: "onTouched",
  });

  const onSubmit = (values) => {
    requestPasswordResetMutation(values.email, {
      onSuccess: () => {
        toastService.success("Reset link sent to your email");
        setTimeout(() => {
          navigate("/auth/login");
        }, 1000);
      },
      onError: (_error) => {
        toastService.error("Failed to send reset link");
      },
    });
  };

  return (
    <AuthLayout>
      <AuthCard
        title="Forgot Password"
        subtitle={
          <div className="text-black-50 text-xs md:text-sm">
            Enter your email to receive a reset link
          </div>
        }
      >
        <form
          className="flex flex-col gap-2 md:gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Controller
            name="email"
            control={control}
            rules={{
              validate: (v) => requestPasswordResetValidators.email(v) ?? true,
            }}
            render={({ field, fieldState }) => (
              <CustomTextInput
                label="Email:"
                radius="md"
                type="email"
                disabled={isPending}
                styles={{
                  input: {
                    fontWeight: "600",
                    fontSize: "14px",
                  },
                }}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                error={fieldState.error?.message}
              />
            )}
          />
          <CustomButton
            type="submit"
            radius="xl"
            size="sm"
            fullWidth
            disabled={isPending}
            loading={isPending}
          >
            Recover my account
          </CustomButton>
        </form>
      </AuthCard>
    </AuthLayout>
  );
}

export default RequestPasswordReset;
